import * as types from './_actionTypes';

const initialState = {
  availableQuizzes: [],
  currentQuiz: null,
  quizAnswers: {},
  quizResults: [],
  loading: false,
  submitting: false,
  error: null
};

const studentQuizzesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_AVAILABLE_QUIZZES_REQUEST:
    case types.FETCH_QUIZ_RESULTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_AVAILABLE_QUIZZES_SUCCESS:
      return {
        ...state,
        loading: false,
        availableQuizzes: action.payload,
        error: null
      };
    
    case types.FETCH_QUIZ_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        quizResults: action.payload,
        error: null
      };
    
    case types.FETCH_AVAILABLE_QUIZZES_FAILURE:
    case types.FETCH_QUIZ_RESULTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case types.START_QUIZ_SUCCESS:
      return {
        ...state,
        currentQuiz: action.payload,
        quizAnswers: {},
        error: null
      };
    
    case types.START_QUIZ_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    
    case types.SUBMIT_QUIZ_REQUEST:
      return {
        ...state,
        submitting: true,
        error: null
      };
    
    case types.SUBMIT_QUIZ_SUCCESS:
      return {
        ...state,
        submitting: false,
        currentQuiz: null,
        quizAnswers: {},
        quizResults: [action.payload, ...state.quizResults],
        error: null
      };
    
    case types.SUBMIT_QUIZ_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload
      };
    
    case types.UPDATE_QUIZ_ANSWER:
      return {
        ...state,
        quizAnswers: {
          ...state.quizAnswers,
          [action.payload.questionId]: action.payload.answer
        }
      };
    
    default:
      return state;
  }
};

export default studentQuizzesReducer;